import { CheckBadgeIcon, AcademicCapIcon } from "@heroicons/react/24/outline";
import {
  Badge,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@mindstonehq/ui";
import {
  hasCoachingSignal,
  type CoachingSignals,
} from "~/lib/coaching-signals-types";
import { Trans, Plural } from "@lingui/react/macro";

export default function ProfileCoaching({
  signals,
  isCurrentUser,
}: {
  signals: CoachingSignals | null;
  isCurrentUser: boolean;
}) {
  // Hidden entirely for non-coaches — there's no activity a visitor can do to
  // "earn" this section, so (unlike Community) we don't show an owner prompt.
  if (!hasCoachingSignal(signals)) return null;

  const { sessionsDelivered } = signals;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <Trans>Mindstone AI Coach</Trans>
          <Badge variant="secondary" className="gap-1">
            <CheckBadgeIcon className="size-3" />
            <Trans>Verified</Trans>
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <section className="flex items-center gap-2">
          <AcademicCapIcon className="size-5 text-primary" />
          <p className="text-sm">
            {sessionsDelivered > 0 ? (
              <Plural
                value={sessionsDelivered}
                one="# coaching session delivered"
                other="# coaching sessions delivered"
              />
            ) : (
              <span className="text-foreground">
                <Trans>Verified Mindstone AI coach</Trans>
              </span>
            )}
          </p>
        </section>

        {isCurrentUser && (
          <p className="text-xs text-muted-foreground">
            <Trans>Visible on your public profile.</Trans>
          </p>
        )}
      </CardContent>
    </Card>
  );
}
